'use strict';

import { transactionTypeMap } from '../../constants';

angular.module('cgmemApp')
	.controller('AdminTransactionsCtrl', function ($rootScope, $scope, $http, AppConfig) {

		this.xTransactions = [];

		this.startOpen = false;
		this.endOpen = false;

		this.filter = {
			endDate: new Date(),
			startDate: new Date(),
			transactionType: null,
			productCode: null
		}

		this.filter.startDate.setDate(this.filter.endDate.getDate() - 7);

		this.transactionTypeMap = transactionTypeMap;
		this.productCodeMap = {};

		AppConfig.get()
			.then(appConfig => {
				this.productMap = appConfig.products.reduce((acc, p) => {
					acc[p.productCode] = p.productName;
					return acc;
				}, {})
			})


		this.toggleDetail = (xt) => {
			xt.showDetail = !xt.showDetail;
			if (xt.showDetail && !xt.detail) {
				$http.get('/api/transactions/' + xt.t._id)
					.then(r => xt.detail = r.data)
					.catch(err => $rootScope.$emit('Problem obtaining transaction detail: ' + err.message))
			}
		}

		$scope.$watchGroup(['$ctrl.filter.startDate', '$ctrl.filter.endDate', '$ctrl.filter.transactionType', '$ctrl.filter.productCode'], (newv, oldv) => {
			this.xTransactions = [];
			$http.get('/api/transactions', {
				params: {
					start: this.filter.startDate.getTime(),
					end: this.filter.endDate.getTime(),
					type: this.filter.transactionType,
					productcode: this.filter.productCode
				}
			})
				.then(r => r.data.map(t => this.xTransactions.push({ t, showDetail: false, detail: null })))
				.catch(err => $rootScope.$emit('generalAlert', 'Problem obtaining transactions: ' + err.message));
		})
	});